import { ACTIONS } from './actionTypes';
export function setConversations(conversations, request, paging) {
  return {
    type: ACTIONS.SET_CONVERSATIONS,
    conversations: conversations,
    request: request,
    paging: paging
  };
}
export function setConversationsFetchingStatus(fetching) {
  return {
    type: ACTIONS.SET_CONVERSATIONS_FETCHING_STATUS,
    fetching: fetching
  };
}
export function setConversationsSearch(search) {
  return {
    type: ACTIONS.SET_CONVERSATIONS_SEARCH,
    search: search
  };
}
export function setConversationsSearchResults(results) {
  return {
    type: ACTIONS.SET_CONVERSATIONS_SEARCH_RESULTS,
    results: results
  };
}
export function setConversationsFilter(filter) {
  return {
    type: ACTIONS.SET_CONVERSATIONS_FILTER,
    filter: filter
  };
}
export function setConversation(conversation) {
  return {
    type: ACTIONS.SET_CONVERSATION,
    conversation: conversation
  };
}
export function setConversationMessages(conversation) {
  return {
    type: ACTIONS.SET_CONVERSATION_MESSAGES,
    conversation: conversation
  };
}
export function addConversationMessages(conversation) {
  return {
    type: ACTIONS.ADD_CONVERSATION_MESSAGES,
    conversation: conversation
  };
}
export function addNotificationMessages(conversation) {
  return {
    type: ACTIONS.ADD_NOTIFICATION_MESSAGES,
    conversation: conversation
  };
}
export function updateLastMessage(conversations) {
  return {
    type: ACTIONS.UPDATE_LAST_MESSAGE,
    conversations: conversations
  };
}
export function updateCurrentLastMessage(conversationID) {
  return {
    type: ACTIONS.UPDATE_CURRENT_LAST_MESSAGE,
    conversationID: conversationID
  };
}
export function addMessage(conversationID, message, author) {
  return {
    type: ACTIONS.ADD_NEW_MESSAGE,
    conversationID: conversationID,
    message: message,
    author: author
  };
}
export function replaceMessage(conversationID, message, author) {
  return {
    type: ACTIONS.REPLACE_MESSAGE,
    conversationID: conversationID,
    message: message,
    author: author
  };
}
export function addAdmins(conversationID, members) {
  return {
    type: ACTIONS.ADD_ADMINS,
    conversationID: conversationID,
    members: members
  };
}
export function removeAdmins(conversationID, members) {
  return {
    type: ACTIONS.REMOVE_ADMINS,
    conversationID: conversationID,
    members: members
  };
}
export function addMember(conversationID, member) {
  return {
    type: ACTIONS.ADD_MEMBER,
    conversationID: conversationID,
    member: member
  };
}
export function removeMembers(conversationID, members) {
  return {
    type: ACTIONS.REMOVE_MEMBERS,
    conversationID: conversationID,
    members: members
  };
}
export function removeConversation(conversationID) {
  return {
    type: ACTIONS.REMOVE_CONVERSATION,
    conversationID: conversationID
  };
}
export function updateCurrentTitle(conversationID, title) {
  return {
    type: ACTIONS.UPDATE_CURRENT_TITLE,
    conversationID: conversationID,
    title: title
  };
}
export function resetNewMessagesCount(conversationID) {
  return {
    type: ACTIONS.RESET_NEW_MESSAGES_COUNT,
    conversationID: conversationID
  };
}
export function updateMessage(conversationID, message) {
  return {
    type: ACTIONS.UPDATE_MESSAGE,
    conversationID: conversationID,
    message: message
  };
}
export function setSelectedConversation(conversationID) {
  return {
    type: ACTIONS.SET_SELECTED_CONVERSATION,
    conversationID: conversationID
  };
}
export function setCurrentView(currentView) {
  return {
    type: ACTIONS.SET_CURRENT_VIEW,
    currentView: currentView
  };
}
export function announceCall(from) {
  return {
    type: ACTIONS.SET_ANNOUNCE_CALL,
    from: from
  };
}
export function rejectCall(from) {
  return {
    type: ACTIONS.SET_ANNOUNCE_CALL,
    from: from
  };
}
export function setCollapsed(collapsed) {
  return {
    type: ACTIONS.SET_COLLAPSED,
    collapsed: collapsed
  };
}
export function setPip(pip) {
  return {
    type: ACTIONS.SET_PIP,
    pip: pip
  };
}
export function setNewConversationMembers(members) {
  return {
    type: ACTIONS.SET_NEW_CONVERSATION_MEMBERS,
    members: members
  };
}
export function setOnlineMembers(members) {
  return {
    type: ACTIONS.SET_ONLINE_MEMBERS,
    members: members
  };
}
export function addOnlineMember(memberId) {
  return {
    type: ACTIONS.ADD_ONLINE_MEMBER,
    memberId: memberId
  };
}
export function removeOnlineMember(memberId) {
  return {
    type: ACTIONS.REMOVE_ONLINE_MEMBER,
    memberId: memberId
  };
}
export function setXGroup(xGroup) {
  return {
    type: ACTIONS.SET_X_GROUP,
    xGroup: xGroup
  };
}